import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Amplify, { Analytics, Auth } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue';

import moment from 'moment';
import VueMoment from 'vue-moment';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import * as Sentry from '@sentry/vue';

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
import { isLocalhost } from '@/constants/constants';

Vue.use(VueTour);

import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClinicMedical,
  faStethoscope,
  faPills,
  faTasks,
  faBullseye,
  faChartBar,
  faTable,
  faDownload,
  faTimes,
  faExpand,
  faStar as fasStar,
  faThumbsUp as fasThumbsUp,
  faThumbsDown as fasThumbsDown,
  faFlag as fasFlag,
  faExpandAlt,
  faSlidersH,
  faChevronRight,
  faChevronDown,
  faExternalLinkAlt as fasExternalLinkAlt,
  faBell,
} from '@fortawesome/free-solid-svg-icons';
import {
  faStar as farStar,
  faThumbsUp as farThumbsUp,
  faThumbsDown as farThumbsDown,
  faFlag as farFlag,
  faFileAlt as farFileAlt,
  faQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGtag from 'vue-gtag';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import { logError } from './utils/loggerUtils';

//construct eventBus
export const eventBus = new Vue();

Analytics.autoTrack('session', {
  enable: true,
});

Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'SPA',
});

Vue.prototype.heap = window.heap;

Amplify.configure({
  ...aws_exports,
  graphql_headers: async () => {
    try {
      const token = (await Auth.currentSession()).idToken.jwtToken;
      return { Authorization: token };
    } catch (e) {
      logError(e);
      return {};
    }
  },
});
Auth.configure(aws_exports);

library.add(faClinicMedical);
library.add(faStethoscope);
library.add(faPills);
library.add(faTasks);
library.add(faBullseye);
library.add(faTimes);
library.add(faChartBar);
library.add(faTable);
library.add(faDownload);
library.add(fasThumbsUp);
library.add(fasThumbsDown);
library.add(farThumbsUp);
library.add(farThumbsDown);
library.add(fasFlag);
library.add(farFlag);
library.add(faQuestionCircle);
library.add(faExpand);
library.add(faExpandAlt);
library.add(faSlidersH);
library.add(fasStar);
library.add(farStar);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(farFileAlt);
library.add(fasExternalLinkAlt);
library.add(faBell);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVueIcons);
Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-159215054-2' },
  },
  router
);

Vue.use(Autocomplete);

Vue.directive('visible', (el, bind) => {
  el.style.visibility = bind.value ? 'visible' : 'hidden';
});

if (!isLocalhost) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    normalizeDepth: 5,
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
